
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/canada-post",
      function () {
        return require("private-next-pages/partners/canada-post.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/canada-post"])
      });
    }
  